<template>
  <section class="stats-section" id="stats">
    <div class="container">
      <div class="section-header reveal">
        <span class="label">{{ $store.getters.t('stats.subtitle') }}</span>
        <h2>{{ $store.getters.t('stats.title') }}</h2>
      </div>
      <div class="stats-grid reveal">
        <div class="stat-card" v-for="(card, i) in $store.getters.t('stats.cards')" :key="i">
          <span class="stat-value">{{ card.value }}</span>
          <span class="stat-label">{{ card.label }}</span>
          <div class="stat-shimmer"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: 'StatsSection' }
</script>

<style scoped>
.stats-section {
  padding: 0 0 100px;
}
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}
.stat-card {
  background: linear-gradient(180deg, rgba(30,41,59,.7) 0%, rgba(20,30,50,.8) 100%);
  border: 1px solid rgba(255,255,255,.04);
  border-radius: 16px;
  padding: 36px 20px;
  text-align: center;
  transition: all .4s;
  position: relative;
  overflow: hidden;
}
.stat-card:hover {
  transform: translateY(-4px);
  border-color: rgba(59,130,246,.15);
  box-shadow: 0 12px 32px rgba(0,0,0,.25);
}
.stat-shimmer {
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(59,130,246,.4), transparent);
  opacity: 0;
  transition: opacity .4s;
}
.stat-card:hover .stat-shimmer { opacity: 1; }
.stat-value {
  display: block;
  font-size: 34px;
  font-weight: 800;
  background: linear-gradient(135deg, #93c5fd, #3b82f6, #2563eb);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 10px;
  letter-spacing: -.02em;
}
.stat-label {
  display: block;
  font-size: 14px;
  color: #94a3b8;
  font-weight: 500;
}
@media (max-width: 768px) {
  .stats-grid { grid-template-columns: repeat(2, 1fr); }
  .stat-value { font-size: 26px; }
  .stat-card { padding: 28px 16px; }
}
@media (max-width: 480px) {
  .stats-grid { grid-template-columns: 1fr; }
}
</style>
